module.exports = __webpack_public_path__ + "static/media/Drifblim_gaussian2.f59f9ae9.png";